import React from 'react';
import { hot } from 'react-hot-loader'

// middleman-dev http://localhost:3004/?type=middleman&home=CrystalPalace&away=WestHam&date=2021-01-26
import {token as manutdwestham} from './manutdwestham'
import {token as atalantalazio} from './atalantalazio'
import {token as tottenhamliverpool} from './tottenhamliverpool'
import {token as mancitytottenham} from './mancitytottenham'
import {token as manutdrealsociedad} from './manutdrealsociedad'
import {token as races01032021} from './races01032021'
import {token as mixedraces01032021} from './mixedraces01032021'
import {token as psgbarcelona} from './psgbarcelona'
import {token as psgbarcelonasaor} from './psgbarcelonasaor'
import {token as chelseaatleticomadrid} from './chelseaatleticomadrid'
import {token as cm240921} from './cm240921'
import {token as cs240921} from './cs240921'
import {token as h_240921} from './h_240921'
import {token as skijumping} from './skijumping'
import {token as cycling} from './cycling'
import {token as cricket1} from './cricket1'
import {token as cricket2} from './cricket2'
// combos-dev http://localhost:3004/?type=combos&league=PremierLeague&date=2021-01-26

import {token as mixed03022021} from './mixed03022021'
import {token as mixed04022021} from './mixed04022021'
import {token as mixed05022021, token100001 as Mixed05022021} from './mixed05022021'
import {token as england18032021, token100001 as England18032021} from './england18032021'
import {token as worldcupqualifiers25032021} from './worldcupqualifiers25032021'
import {token as mixed25032021} from './mixed25032021'

import {token as premierLeague05022021, token100001 as PremierLeague05022021} from './premierleague05022021'

import {token as premierleague23042021} from './premierleague23042021'
import {token as realbetis} from './realbetis'
import {token as realmadridbetis} from './realmadridbetis'
import {token as rmbetis} from './rmbetis'
import {token as mixed23042021} from './mixed23042021'

import {token as singleVenue12112021} from './singlevenue12112021'
import {token as mixedVenue12112021} from './mixedvenue12112021'

interface State {
  valid: boolean|undefined|null
  date: string
  apikey: boolean
}

interface Props {}

class App extends React.Component<Props, State> {
  constructor(props: any) {
    super(props)
    this.state = {
      valid: undefined,
      date: '',
      apikey: false
    }
  }

  render() {
    const url: URL = new URL(window.location.href)
    const home: string|null = url.searchParams.get("home")
    const away: string|null = url.searchParams.get("away")
    const date: string|null = url.searchParams.get("date")
    const type: string|null = url.searchParams.get("type")
    const league: string|null = url.searchParams.get("league")
    const subtype: string|null = url.searchParams.get("subtype")
    let linkExpired: boolean = false
    // middleman
    if ((!type || type === 'middleman') && (
    home === 'Atalanta' && away === 'Lazio' && date === '2021-01-27'
    || home === 'Tottenham' && away === 'Liverpool' && date === '2021-01-28'
    || home === 'ManUtd' && away === 'WestHam' && date === '2021-02-09'
    || home === 'ManCity' && away === 'Tottenham' && date === '2021-02-12'
    || home === 'ManUtd' && away === 'RealSociedad' && date === '2021-02-25'
    || home === 'PSG' && away === 'Barcelona' && date === '2021-03-10'
    || home === 'Chelsea' && away === 'AtleticoMadrid' && date === '2021-03-17'
    || home === 'SunrisersHyderabad' && away === 'KolkataKnightRiders' && date === '2021-04-11'
    || home === 'SunrisersHyderabad' && away === 'KolkataKnightRiders' && date === '2021-09-02'
    || home === 'RealMadrid' && away === 'Betis' && date === '2021-04-23'
    || home === 'Toronto' && away === 'Montreal' && date === '2021-09-24'
    || home === 'Ski' && away === 'Jumping' && date === '2021-09-24'
    || home === 'Cycling' && away === 'ParisRoubaix' && date === '2021-09-24'
    )) {
      let skipExpiry: boolean = false
      if (home === 'Atalanta' && away === 'Lazio' && date === '2021-01-27'
      || home === 'ManCity' && away === 'Tottenham' && date === '2021-02-12'
      || home === 'PSG' && away === 'Barcelona' && date === '2021-03-10'
      || home === 'SunrisersHyderabad' && away === 'KolkataKnightRiders' && date === '2021-09-02'
      || home === 'SunrisersHyderabad' && away === 'KolkataKnightRiders' && date === '2021-04-11'
      || home === 'Toronto' && away === 'Montreal' && date === '2021-09-24'
      || home === 'Ski' && away === 'Jumping' && date === '2021-09-24'
      || home === 'Cycling' && away === 'ParisRoubaix' && date === '2021-09-24'
      ) {
        skipExpiry = true
      }

      let time: number = (new Date()).getTime() - 14 * 24 * 60 * 60 * 1000
      if (!skipExpiry && (new Date(time)).toISOString().substring(0,10) > date) {
        linkExpired = true
      } else {
        let token: string
        if (home === 'Atalanta' && away === 'Lazio' && date === '2021-01-27') {
          token = atalantalazio
        } else if (home === 'Tottenham' && away === 'Liverpool' && date === '2021-01-28') {
          token = tottenhamliverpool
        } else if (home === 'ManUtd' && away === 'WestHam' && date === '2021-02-09') {
          token = manutdwestham
        } else if (home === 'ManUtd' && away === 'RealSociedad' && date === '2021-02-25') {
          token = manutdrealsociedad
        } else if (home === 'ManCity' && away === 'Tottenham' && date === '2021-02-12') {
          token = mancitytottenham
        } else if (home === 'PSG' && away === 'Barcelona' && date === '2021-03-10' && subtype === 'saor') {
          token = psgbarcelonasaor
        } else if (home === 'PSG' && away === 'Barcelona' && date === '2021-03-10') {
          token = psgbarcelona
        } else if (home === 'Chelsea' && away === 'AtleticoMadrid' && date === '2021-03-17') {
          token = chelseaatleticomadrid
        } else if (home === 'SunrisersHyderabad' && away === 'KolkataKnightRiders' && date === '2021-04-11') {
          token = cricket1
        } else if (home === 'SunrisersHyderabad' && away === 'KolkataKnightRiders' && date === '2021-09-02') {
          token = cricket2
        } else if (home === 'RealMadrid' && away === 'Betis' && date === '2021-04-23' && subtype === 'saor') {
          token = realbetis
        } else if (home === 'RealMadrid' && away === 'Betis' && date === '2021-04-23' && subtype === 'betrix') {
          token = rmbetis
        } else if (home === 'RealMadrid' && away === 'Betis' && date === '2021-04-23') {
          token = realmadridbetis
        } else if (home === 'Toronto' && away === 'Montreal' && date === '2021-09-24') {
          token = h_240921
        } else if (home === 'Ski' && away === 'Jumping' && date === '2021-09-24') {
          token = skijumping
        } else if (home === 'Cycling' && away === 'ParisRoubaix' && date === '2021-09-24') {
          token = cycling
        }
        const Link: string = 'https://' + (type === 'middleman' ? 'oddscraft-test.firebaseapp.com' : 'betrix-middleman.firebaseapp.com') + '?token=' + token
        window.location.href = Link
      }
    } else if ((type === 'combos' || type === 'combostest') && (
      league === 'Mixed' && !home && !away && date === '2021-02-03'
      || league === 'Mixed' && !home && !away && date === '2021-02-04'
      || league === 'Mixed' && !home && !away && date === '2021-02-05'
      || league === 'PremierLeague' && !home && !away && date === '2021-02-05'
      || league === 'SingleVenue' && !home && !away && date === '2021-03-01'
      || league === 'MixedVenues' && !home && !away && date === '2021-03-01'
      || league === 'England' && !home && !away && date === '2021-03-18'
      || league === 'WorldCupQualifiers' && !home && !away && date === '2021-03-25'
      || league === 'SingleVenue' && !home && !away && date === '2021-11-12'
      || league === 'PremierLeague' && !home && !away && date === '2021-04-23'
      || league === 'MixedVenues' && !home && !away && date === '2021-11-12'
      || league === 'Mixed' && !home && !away && date === '2021-09-24'
      || league === 'PremierLeague' && !home && !away && date === '2021-09-24'
      )) {
      let skipExpiry: boolean = false

      if (league === 'Mixed' && date === '2021-02-05' || league === 'PremierLeague' && date === '2021-02-05'
      || league === 'SingleVenue' && !home && !away && date === '2021-11-12'
      || league === 'MixedVenues' && !home && !away && date === '2021-11-12'
      || league === 'Mixed' && !home && !away && date === '2021-09-24'
      || league === 'PremierLeague' && !home && !away && date === '2021-09-24'
      ) {
        skipExpiry = true
      }

      let time: number = (new Date()).getTime() - 14 * 24 * 60 * 60 * 1000
      if (!skipExpiry && (new Date(time)).toISOString().substring(0,10) > date) {
        linkExpired = true
      } else {
        let token: string
        if (league === 'Mixed' && date === '2021-02-03') {
          token = mixed03022021
        } else if (league === 'Mixed' && date === '2021-02-04') {
          token = mixed04022021
        } else if (league === 'Mixed' && date === '2021-02-05') {
          token = subtype === 'max' ? Mixed05022021 : mixed05022021
        } else if (league === 'PremierLeague' && date === '2021-02-05') {
          token = subtype === 'max' ? PremierLeague05022021 : premierLeague05022021
        } else if (league === 'England' && date === '2021-03-18') {
          token = subtype === 'max' ? England18032021 : england18032021
        } else if (league === 'SingleVenue' && date === '2021-03-01') {
          token = races01032021
        } else if (league === 'MixedVenues' && date === '2021-03-01') {
          token = mixedraces01032021
        } else if (league === 'WorldCupQualifiers' && date === '2021-03-25') {
          token = worldcupqualifiers25032021
        } else if (league === 'MixedVenues' && date === '2021-03-25') {
          token = mixed25032021 
        } else if (league === 'PremierLeague' && date === '2021-04-23') {
          token = premierleague23042021 
        } else if (league === 'MixedVenues' && date === '2021-04-23') {
          token = mixed23042021
        } else if (league === 'Mixed' && date === '2021-09-24') {
          token = cm240921
        } else if (league === 'PremierLeague' && date === '2021-09-24') {
          token = cs240921
        } else if (league === 'MixedVenues' && date === '2021-11-12') {
          token = mixedVenue12112021
        } else if (league === 'SingleVenue' && date === '2021-11-12') {
          token = singleVenue12112021
        }
        const Link: string = 'https://' + (type === 'combos' ? 'combo-ways.firebaseapp.com' : type === 'combostest' ? 'combos-test.firebaseapp.com' : '') + '?token=' + token
        window.location.href = Link
      }
    }

    return(<div>{linkExpired ? 'The link is expired.' : 'Loading...'}</div>)
  }
}

declare const module: object
export default hot(module)(App)